module.exports = __webpack_public_path__ + "img/logo_white.05a0ee12.svg";